import React, { useState } from 'react';
import { t } from '@lingui/core/macro';

import Trophy from '@rover/icons/svg/trophy.svg';
import { Box, Button, Flex, Heading, Paragraph, Text } from '@rover/kibble/core';
import Modal from '@rover/kibble/official-patterns/Modal';
import IconBlock from '@rover/kibble/patterns/IconBlock/IconBlock';
import type { EnhancedPersonSitterProfile } from '@rover/rsdk/src/apiClient/latest/model/enhancedPersonSitterProfile';
import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';

import { CatCareDetailsModalClickEvent } from '../../analyticsEvents';
import { SitterProfileVersion } from '../../hooks/useRevampProfileContext';
import AutoHeight from '../../utils/AutoHeight/AutoHeight';
import SitterInformation from '../SitterInformation/SitterInformation';

type Props = {
  sitter: EnhancedPersonSitterProfile;
  userOpk?: string;
  pageVariant?: SitterProfileVersion;
};
const CatProviderProfileModal = ({ sitter, userOpk, pageVariant }: Props): JSX.Element => {
  const [catProviderProfileModalIsOpen, setCatProviderProfileModalIsOpen] = useState(false);

  return (
    <>
      <Button
        testID="cat-provider-profile-open-modal"
        onClick={() => {
          setCatProviderProfileModalIsOpen(true);
          emitAnalyticsEvent(
            new CatCareDetailsModalClickEvent({
              personId: userOpk,
              sitterId: sitter.opk,
              ...(pageVariant && { pageVariant }),
            })
          );
        }}
        width={['100%', 'auto']}
        mt="6x"
      >
        {t`View full cat experience`}
      </Button>
      <Modal
        isOpen={catProviderProfileModalIsOpen}
        onRequestClose={() => setCatProviderProfileModalIsOpen(false)}
      >
        <AutoHeight>
          <Box sx={{ overflowX: 'hidden', maxHeight: 'calc(100vh - 80px)' }}>
            <Flex flexDirection="column">
              <SitterInformation
                sitter={sitter}
                sitterImage={sitter.catProviderProfile?.profilePhoto?.bigThumb}
                justifyContent="left"
              />
              <Flex mb="8x" mt="1x">
                <IconBlock iconSize="16px" iconMargin="0x" icon={Trophy} title="" />
                <Text ml="3x">
                  {sitter.catProviderProfile?.yearsOfExperience} {t`Years of cat care experience`}
                </Text>
              </Flex>
              <Heading webProps={{ as: 'h3' }}>{sitter.catProviderProfile?.headline}</Heading>
              <Paragraph mb="8x" mt="1x" sx={{ whiteSpace: 'pre-line' }}>
                {sitter.catProviderProfile?.careExperience}
              </Paragraph>
            </Flex>
            <Flex pb="8x" mt="2x" px="1x">
              <Button
                onClick={() => setCatProviderProfileModalIsOpen(false)}
                variant="default"
                size="default"
                aria-label="Dismiss modal"
                fullWidth
              >
                {t`Close`}
              </Button>
            </Flex>
          </Box>
        </AutoHeight>
      </Modal>
    </>
  );
};
export default CatProviderProfileModal;
